import { render, staticRenderFns } from "./SvgSection15.vue?vue&type=template&id=b0176b86&"
import script from "./SvgSection15.vue?vue&type=script&lang=js&"
export * from "./SvgSection15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports